import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxSelectBoxModule } from 'devextreme-angular';
import { CampaignSelectorComponent } from './campaign-selector.component';

@NgModule({
  declarations: [CampaignSelectorComponent],
  imports: [
    CommonModule,
    DxSelectBoxModule
  ],
  exports: [CampaignSelectorComponent]
})
export class CampaignSelectorModule { }
